import React, {useEffect, useState } from 'react';
import Menu from '../Menu';
import MyProfile from '../Profile/MyProfile';
import MyRetail from '../Profile/MyRetail';
import MyPreferences from '../Profile/MyPreferences';
import './Landing.css';
import LoadingIndicator from '../../Layout/LoadingIndicator';
import BackToHome from '../../Layout/BackToHome';
import { useIdleTimer } from 'react-idle-timer'
import { HashRouter, Route } from 'react-router-dom';

import useApiGetWithToken from '../../DataServices/useApiGetWithToken';

// The "home page" of the CDP. It will switch the content based ont eh state page.
const Landing = (props) => {
  const account = props.authProps.account;

  // Logout inactive user. The idle duration is a config value.
  const handleOnIdle = event => {
    props.authProps.instance.logout()
  }

  const timeoutInterval = 1000 * 60 * parseInt(process.env.REACT_APP_APPLICATION_IDLE_TIMEOUT);

  useIdleTimer({
    timeout: timeoutInterval,
    onIdle: handleOnIdle,
    debounce: 500
  })

  // The state variable page can be home, my-profile, my-retail and my-preferences.
  const [page, setPage] = useState('home');
  const [customer, setCustomer] = useState([]);
  const [customerLoaded, setCustomerLoaded] = useState(false);
  //const [referrer, setReferrer] = useState(null);
  console.log(document.referrer);
  let displayPage = '';
  
  // Loading the profile data fo the currently logged in user.
  const { data, error, isLoaded } = useApiGetWithToken("/customer/"+account.localAccountId );

  useEffect(() => {
    setCustomer(data);
    (data.length != 0) ? setCustomerLoaded(true) : setCustomerLoaded(false);
  }, [data]);

  if (error !== null) {
    return <div>Error: {error.message}</div>;
  }
  // Display loading indicator until the data is retrieved.
  if (!isLoaded || !customerLoaded) {
    return <LoadingIndicator />;
  }
  
  if (isLoaded && customerLoaded){
    return (
      <main className="main" id="maincontent">
        <HashRouter>
        {(page!=='home')?<BackToHome setPage={setPage} />:''}
          <Route exact={true} path="/" render={() => (
            <Menu 
              setPage={setPage} 
              customer={customer}
              instance={props.authProps.instance}
              />
            )}
          />
          <Route path="/my-profile" render={() => (
            <MyProfile 
                setPage={setPage} 
                setCustomer={setCustomer}
                customer={customer}
                authProps={props.authProps}
              />
              )}
          />
          <Route path="/my-retail" render={() => (
            <MyRetail 
                setPage={setPage} 
                customer={customer}
                authProps={props.authProps}
              />
            )}
          />
          <Route path="/my-preferences" render={() => (
            <MyPreferences 
                setPage={setPage} 
                customer={customer}
                authProps={props.authProps}
              />
            )}
          />
        </HashRouter>
      </main>
    
    );  
  }
  return <LoadingIndicator />
}

export default Landing;